<template>
  <v-col cols="12">
    <gg-card>
      <gg-card-header>
        Your Email Accounts
      </gg-card-header>
      <gg-card-text>
        <v-data-table :headers="headers"
                      :items="emails.data"
                      :loading="emails.loading_status">
          <template v-slot:item.email="{ item }">
            {{ item.email }}
          </template>
          <template v-slot:item.usage="{ item }">
            <v-progress-linear v-if="item.humandiskquota !== 'None'"
                               color="primary"
                               height="26"
                               :value="quotaPercentage(item.diskusedpercent_float)">
              <template v-slot:default="{ value }">
                {{ item.humandiskused }} / {{ item.humandiskquota }}
              </template>
            </v-progress-linear>
            <v-progress-linear v-else
                               color="primary"
                               height="26"
                               value="0">
              <template v-slot:default="{ value }">
                {{ item.humandiskused }} / ∞
              </template>
            </v-progress-linear>
          </template>
          <template v-slot:item.manage="{ item }">
            <div class="">
              <gg-btn secondary class="mr-2" @click="launch_webmail(hosting.id, item.email)">
                Check Webmail
                <v-icon small class="ml-1">mdi-open-in-new</v-icon>
              </gg-btn>

              <v-menu bottom offset-y min-width="180">
                <template v-slot:activator="{ on, attrs }">
                  <gg-btn v-on="on" v-bind="attrs">
                    Manage
                    <v-icon class="ml-1">mdi-chevron-down</v-icon>
                  </gg-btn>
                </template>
                <v-list>
                  <v-list-item @click="triggerPass(item.email, item.domain)">
                    <v-list-item-title>Change Password</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="triggerQuota(item.user, item.domain)">
                    <v-list-item-title>Change Quota</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="triggerConfiguration(item.login)">
                    <v-list-item-title>Mail Configuration</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="triggerRemove(item.email)">
                    <v-list-item-title>Delete</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </template>
        </v-data-table>
      </gg-card-text>
    </gg-card>
    <template>
      <div>
        <v-dialog v-model="modals.password.open" hide-overlay max-width="500px">
          <change-password v-if="modals.password.open" :email="modals.password.email" :domain="modals.password.domain" @close="triggerPass"/>
        </v-dialog>
      </div>
    </template>
    <template>
      <div>
        <change-quota :is-active="modals.quota.open"
                      :user="modals.quota.user"
                      :domain="modals.quota.domain"
                      @close="triggerQuota"
                      @action-completed="getData"
        />
      </div>
    </template>
    <template>
      <div>
          <delete-email v-if="modals.remove.open"
                        :is-active="modals.remove.open"
                        :email="modals.remove.email"
                        @close="triggerRemove"
                        @action-completed="getData"
          />
      </div>
    </template>
    <div>
      <webmail-access-modal :domain="modals.access.domain"
                            :login="modals.access.login"
                            :opened="modals.access.open"
                            @close="modals.access.open = false"></webmail-access-modal>
    </div>
    <div>
      <configuration-modal :opened="modals.configuration.open"
                           :account="modals.configuration.account"
                           @close="modals.configuration.open = false"></configuration-modal>
    </div>
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ChangePassword from './Modals/ChangePassword'
import ChangeQuota from './Modals/ChangeQuota'
import DeleteEmail from './Modals/DeleteEmail'
import WebmailAccessModal from './Modals/WebmailAccessModal'
import ConfigurationModal from './Modals/ConfigurationModal'
import { launch_webmail } from '@/helpers/helpers'

export default {
  name: 'EmailsTable',
  components: {
    ChangeQuota,
    ChangePassword,
    DeleteEmail,
    WebmailAccessModal,
    ConfigurationModal,
  },
  data: () => ({
    headers: [
      { text: 'Account', sortable: true, value: 'email' },
      { text: 'Usage', sortable: true, value: 'usage' },
      { text: 'Actions', sortable: false, value: 'manage', align: 'center', },
    ],
    modals: {
      password: {
        open: false,
        email: '',
        domain: ''
      },
      quota: {
        open: false,
        user: '',
        domain: ''
      },
      remove: {
        open: false,
        email: ''
      },
      access: {
        open: false,
        login: '',
        domain: '',
      },
      configuration: {
        open: false,
        account: '',
      },
    },
  }),
  computed: {
    ...mapGetters({
      emails: 'email/emails',
      hosting: 'hosting'
    }),
  },
  methods: {
    ...mapActions({
      setEmailsData: 'email/setEmailsData',
      reportSuccess: 'reportSuccess',
      reportError: 'reportError',
    }),
    launch_webmail,
    async getData () {
      try {
        await this.setEmailsData(this.$route.query.user)
      } catch (e) {
        this.reportError(e)
      }
    },
    triggerPass (email, domain) {
      this.modals.password.open = !this.modals.password.open
      this.modals.password.email = email
      this.modals.password.domain = domain
    },
    triggerQuota (user, domain) {
      this.modals.quota.open = !this.modals.quota.open
      this.modals.quota.user = user !== undefined ? user : ''
      this.modals.quota.domain = domain !== undefined ? domain : ''
    },
    triggerRemove (email) {
      this.modals.remove.open = !this.modals.remove.open
      this.modals.remove.email = email
    },
    triggerAccess (login, domain) {
      this.modals.access.open = true
      this.modals.access.login = login
      this.modals.access.domain = domain
    },
    triggerConfiguration (account) {
      this.modals.configuration.open = true
      this.modals.configuration.account = account
    },
    quotaPercentage (quotaFloat) {
      return Number.parseInt(quotaFloat)
    },
  },
  async created () {
    await this.getData()
  }
}
</script>
